import { render } from "./AddVpcOffering.vue?vue&type=template&id=6ff24c58&scoped=true"
import script from "./AddVpcOffering.vue?vue&type=script&lang=js"
export * from "./AddVpcOffering.vue?vue&type=script&lang=js"

import "./AddVpcOffering.vue?vue&type=style&index=0&id=6ff24c58&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/cloudstack/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff24c58"]])

export default __exports__